import React, { useEffect } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { api } from "../../../services/api";
import ym from "react-yandex-metrika";

export function PagSeguroFlow({ transactionData, onRequirePersonalInfo }) {

    async function startTransaction() {

        const body = {
            username: transactionData.username,
            server: transactionData.server,
            gateway: transactionData.gateway,
            currencyCode: transactionData.currencyCode,
            token: transactionData.token,
            utm_source: transactionData.utm_source,
            utm_medium: transactionData.utm_medium,
            utm_campaign: transactionData.utm_campaign,
            items: transactionData.items,
        }

        try {
            let response = await api.post("payment/purchase", body);

            if (response.data.status === "fail") {
                // Conta sem os dados pessoais obrigatórios (ex.: telefone): volta para o formulário.
                if (response.data.message === "missing-personal-info" && onRequirePersonalInfo) {
                    onRequirePersonalInfo();
                    return;
                }
                window.location = `/`;
                return;
            }

            ym("reachGoal", "purchase_request");

            document.getElementById("store_id").setAttribute("value", response.data.store_id);
            document.getElementById("return").setAttribute("value", response.data.return);
            document.getElementById("notify_url").setAttribute("value", response.data.notify_url);
            document.getElementById("currency_code").setAttribute("value", response.data.currency_code);
            document.getElementById("order_id").setAttribute("value", response.data.order_id);
            document.getElementById("order_description").setAttribute("value", response.data.order_description);
            document.getElementById("client_email").setAttribute("value", response.data.client_email);
            document.getElementById("amount").setAttribute("value", response.data.amount);
            document.getElementById("hash_key").setAttribute("value", response.data.hash_key);
            document.getElementById("country_payment").setAttribute(
                "value",
                response.data.currency_code === "BRL" ? "BR" : "US"
            );

            if (transactionData.gateway === "pagseguro-card") {
                const paymentGroup = document.createElement("input");
                paymentGroup.setAttribute("type", "hidden");
                paymentGroup.setAttribute("id", "payment_group");
                paymentGroup.setAttribute("name", "payment_group");
                paymentGroup.setAttribute("value", "card");
                document.getElementById("form").appendChild(paymentGroup);
            } else {
                const paymentGroup = document.createElement("input");
                paymentGroup.setAttribute("type", "hidden");
                paymentGroup.setAttribute("id", "payment_id");
                paymentGroup.setAttribute("name", "payment_id");
                paymentGroup.setAttribute("value", "20");
                document.getElementById("form").appendChild(paymentGroup);
            }

            document.getElementById("form").submit();
        } catch (error) {
            console.error("Error:", error);
        }
    }

    useEffect(() => {
        startTransaction();
    }, []);

    return (
        <div className="spinner-div">
            <ProgressSpinner />
            <form
                action="https://billing.boacompra.com/payment.php"
                id="form"
                method="POST"
                name="billing"
                target="_parent"
                className="ng-untouched ng-pristine ng-valid"
            >
                <input id="store_id" name="store_id" type="hidden" value="" />
                <input id="return" name="return" type="hidden" value="" />
                <input id="notify_url" name="notify_url" type="hidden" value="" />
                <input
                    id="currency_code"
                    name="currency_code"
                    type="hidden"
                    value=""
                />
                <input id="order_id" name="order_id" type="hidden" value="" />
                <input
                    id="order_description"
                    name="order_description"
                    type="hidden"
                    value=""
                />
                <input id="amount" name="amount" type="hidden" value="" />
                <input
                    id="client_email"
                    name="client_email"
                    type="hidden"
                    value=""
                />
                <input id="hash_key" name="hash_key" type="hidden" value="" />
                <input
                    id="country_payment"
                    name="country_payment"
                    type="hidden"
                    value=""
                />
            </form>
        </div>
    )
}